import React, { Component } from "react";
import Typography from "material-ui-next/Typography";
import { StyledButton } from "components/support";
import Dialog, { DialogTitle, DialogActions} from "material-ui-next/Dialog";
import Divider from "material-ui-next/Divider";
import DialogContent from "./DialogContent/index";
import IntegrationsList from "./integrations-list";

const formInitialState = {
  enabled: true,
  name: "",
  login: "",
  password: "",
  origin: "",
  paymentType: "",
  auto_accept: false
}

class OrderIntegration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      form: formInitialState,
      editing: false,
      uuid: ""
    };
  }

  handleCloseModal = () => {
    const { presenter } = this.props;

    this.setState({ modal: false });
    presenter.resetErrors(this.state.editing)
  }

  handleSave = () => {
    const { presenter } = this.props;

    presenter.onSave(
      this.state.form,
      this.state.editing,
      this.state.uuid,
      this.handleCloseModal
    )
  }

  changeForm = (field, value) => {
    this.setState({
      form: {
        ...this.state.form,
        [field]: value
      }
    });
  };

  handleEdit = formData => {
    this.setState({
      modal: true,
      editing: true,
      form: {
        enabled: formData.enabled,
        name: formData.name,
        login: formData.username,
        password: formData.password,
        origin: formData.origin,
        paymentType: formData.payment_uuid,
        auto_accept: formData.auto_accept
      },
      uuid: formData.uuid
    });
  };

  handleAddIntegration = () => {
    this.setState({
      modal: true,
      editing: false,
      form: formInitialState
    })
  }

  render() {
    const { viewModel, presenter } = this.props;
    const { data, errors, paymentData, companyUuid } = viewModel;
    const title = `${!this.state.editing ? "Criar" : "Editar"} Integração`;

    return (
      <div style={{ padding: 20 }}>
        <Typography type="headline">Pedidos Externos</Typography>

        <Divider />

        <IntegrationsList
          integrations={data}
          presenter={presenter}
          handleEdit={this.handleEdit}
        />

        <StyledButton
          label="Adicionar Pedido Externo"
          primary
          disabled={!companyUuid}
          style={{ marginTop: 20, pointerEvents: !companyUuid ? "none" : "" }}
          onTouchTap={this.handleAddIntegration}
        />

        <Dialog open={this.state.modal}>
          <DialogTitle type="headline">{title}</DialogTitle>
          <DialogContent
            changeForm={this.changeForm}
            form={this.state.form}
            error={errors}
            paymentData={paymentData}
          />
          <DialogActions style={{ padding: 24, margin: 0 }}>
            <StyledButton flat onClick={this.handleCloseModal}>
              Cancelar
            </StyledButton>
            <StyledButton primary onClick={this.handleSave}>
              Salvar
            </StyledButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default OrderIntegration;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/order_integrations/view.jsx